import React from 'react';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { toggleAddressItems } from '../../../../data/reducers/representOathHearingsReducer';
import RepresentOathHearingsCard from './RepresentOathHearingsCard';
import './RepresentOathHearingsCardsList.css';

/**
 * List component for displaying all hearing cards.
 *
 * @param {Object} props Component props
 * @param {Array} props.items Array of items to display
 * @param {Array} props.selectedItems Array of selected item IDs
 */
const RepresentOathHearingsCardsList = ({ items, selectedItems }) => {
	const dispatch = useDispatch();

	// Only show open items
	const openItems = items.filter((item) => item.is_open);

	const itemsByAddress = _.groupBy(openItems, 'property_address');

	const handleSelectAddress = (addressItems) => {
		dispatch(
			toggleAddressItems(addressItems.map((item) => item.queued_email_id)),
		);
	};

	if (openItems.length === 0) {
		return (
			<div className="represent-oath-hearings-cards-list">
				<div className="no-items-message">
					<p>No open hearings available for representation.</p>
				</div>
			</div>
		);
	}

	return (
		<div className="represent-oath-hearings-cards-list">
			{/* Overall selected-count summary; selection itself happens per address below */}
			<div className="selected-count-summary">
				<strong>{selectedItems.length}</strong> of {openItems.length} selected
			</div>

			{/* Cards grouped by property address */}
			{Object.entries(itemsByAddress).map(([address, addressItems]) => {
				const addressAllSelected = addressItems.every((item) =>
					selectedItems.includes(item.queued_email_id),
				);

				return (
					<div className="address-group" key={address}>
						<div className="address-group-header">
							<label className="select-address-label">
								<input
									type="checkbox"
									checked={addressAllSelected}
									onChange={() => handleSelectAddress(addressItems)}
								/>
								<span>{address}</span>
							</label>
							<span className="address-group-count">
								{addressItems.length} hearing{addressItems.length === 1 ? '' : 's'}
							</span>
						</div>
						<div className="cards-container">
							{addressItems.map((item) => (
								<RepresentOathHearingsCard
									key={item.queued_email_id}
									item={item}
									isSelected={selectedItems.includes(item.queued_email_id)}
									showAddress={false}
								/>
							))}
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default RepresentOathHearingsCardsList;
